import { useMutation } from "@tanstack/react-query";
import { updatePreferences } from "@/api/preferences";
import { usePreferencesManager } from "@/tanstackQuery/queries";

export const useUpdatePreferences = () => {
  const prefsManager = usePreferencesManager();

  return useMutation({
    mutationFn: updatePreferences,

    onMutate: (payload) => {
      const previous = prefsManager.get();
      prefsManager.patch(payload);
      return { previous };
    },

    onSuccess: (data) => {
      prefsManager.replace(data);
    },

    onError: (_error, _payload, context) => {
      if (context?.previous) {
        prefsManager.replace(context.previous);
      }
    },
  });
};
